import {axiosInstances} from "../axios"
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ButtonDTO {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
}

export interface ButtonWithStat {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  sum?: number;
}

export interface ClickButtonMultipleRequest {
  /** @format int32 */
  buttonId?: number;
  /** @format int32 */
  count?: number;
}

export interface ClickButtonRequest {
  timeZoneId?: string | null;
  /** @format int32 */
  buttonId?: number;
}

export interface ClickButtonResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  clickStat?: ClickStatDTO;
}

export interface ClickStatDTO {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  totalClicks?: number;
  /** @format int32 */
  clickCount1?: number;
  /** @format int32 */
  clickCount2?: number;
  /** @format int32 */
  clickCount3?: number;
  /** @format int32 */
  clickCount4?: number;
  /** @format date-time */
  lastKnownClientTime?: string;
}

export interface ClickStatResponse {
  /** @format int32 */
  buttonId?: number;
  buttonName?: string | null;
  /** @format int32 */
  timesClicked?: number;
}

export interface ClickStatisticResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  clickStatDTO?: ClickStatDTO;
}

export interface DeleteUserResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
}

export interface DetailedErrorResponse {
  errorCode?: string | null;
  errorMessage?: string | null;
}

export interface GetAllUsersResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  users?: UserDTO[] | null;
}

export interface GetCSVRequest {
  /** @format int64 */
  startTime?: number;
  /** @format int64 */
  endTime?: number;
}

export interface GetCSVResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  data?: string | null;
}

export interface GetClicksReportRequest {
  /** @format int64 */
  startTime?: number;
  /** @format int64 */
  endTime?: number;
  /** @format int32 */
  buttonId?: number | null;
  username?: string | null;
  location?: string | null;
}

export interface GetClicksReportResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  /** @format int64 */
  startTime?: number;
  /** @format int64 */
  endTime?: number;
  clickReport?: Record<string, ClickStatResponse>;
}

export interface GetEnabledButtonsResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  buttons?: ButtonDTO[] | null;
}

export interface GetReportResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  /** @format int64 */
  startUtcTimestamp?: number;
  /** @format int64 */
  endUtcTimestamp?: number;
  reports?: ReportChunk[] | null;
}

export interface GetUserByIdResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  user?: UserDTO;
}

export interface LoginUserRequest {
  username?: string | null;
  password?: string | null;
  timeZoneId?: string | null;
}

export interface LoginUserResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  token?: string | null;
  clickStat?: ClickStatDTO;
  user?: UserDTO;
}

export interface RegisterUserRequest {
  username?: string | null;
  password?: string | null;
  locationTag?: string | null;
  enableExtraOptions?: boolean | null;
}

export interface RegisterUserResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  user?: UserDTO;
}

export interface ReportChunk {
  /** @format int64 */
  utcTimestamp?: number;
  usCentralDate?: string | null;
  itemsWithStat?: ButtonWithStat[] | null;
  /** @format int32 */
  total?: number;
}

export interface UnClickButtonRequest {
  /** @format int32 */
  buttonId?: number;
}

export interface UnClickButtonResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  clickStat?: ClickStatDTO;
}

export interface UpdateUserRequest {
  /** @format int32 */
  userId?: number;
  username?: string | null;
  password?: string | null;
  locationTag?: string | null;
  enableExtraOptions?: boolean | null;
}

export interface UpdateUserResponse {
  /** @format int32 */
  httpErrorCode?: number;
  errorMessage?: string | null;
  detailedErrors?: DetailedErrorResponse[] | null;
  user?: UserDTO;
}

export interface UserDTO {
  /** @format int32 */
  id?: number;
  username?: string | null;
  locationTag?: string | null;
  enableExtraOptions?: boolean;
  /** @format date-time */
  created?: string | null;
  /** @format date-time */
  lastLogged?: string | null;
  isDeleted?: boolean;
  isAdmin?: boolean;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstances.mainAxios;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title WellFeedBackend
 * @version 1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1UserDetail
     * @request GET:/api/admin/v1/user/{userId}
     */
    adminV1UserDetail: (userId: number, params: RequestParams = {}) =>
      this.request<GetUserByIdResponse, GetUserByIdResponse>({
        path: `/api/admin/v1/user/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1UserDelete
     * @request DELETE:/api/admin/v1/user/{userId}
     */
    adminV1UserDelete: (userId: number, params: RequestParams = {}) =>
      this.request<DeleteUserResponse, DeleteUserResponse>({
        path: `/api/admin/v1/user/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1UserAllList
     * @request GET:/api/admin/v1/user/all
     */
    adminV1UserAllList: (params: RequestParams = {}) =>
      this.request<GetAllUsersResponse, GetAllUsersResponse>({
        path: `/api/admin/v1/user/all`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1UserCreate
     * @request POST:/api/admin/v1/user
     */
    adminV1UserCreate: (data: RegisterUserRequest, params: RequestParams = {}) =>
      this.request<RegisterUserResponse, RegisterUserResponse>({
        path: `/api/admin/v1/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1UserUpdate
     * @request PUT:/api/admin/v1/user
     */
    adminV1UserUpdate: (data: UpdateUserRequest, params: RequestParams = {}) =>
      this.request<UpdateUserResponse, UpdateUserResponse>({
        path: `/api/admin/v1/user`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1ReportCreate
     * @request POST:/api/admin/v1/report
     */
    adminV1ReportCreate: (data: GetClicksReportRequest, params: RequestParams = {}) =>
      this.request<GetClicksReportResponse, GetClicksReportResponse>({
        path: `/api/admin/v1/report`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1Reportv2Detail
     * @request GET:/api/admin/v1/reportv2/{userId}
     */
    adminV1Reportv2Detail: (userId: number, params: RequestParams = {}) =>
      this.request<GetReportResponse, GetReportResponse>({
        path: `/api/admin/v1/reportv2/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminV1GetcsvCreate
     * @request POST:/api/admin/v1/getcsv
     */
    adminV1GetcsvCreate: (data: GetCSVRequest, params: RequestParams = {}) =>
      this.request<GetCSVResponse, GetCSVResponse>({
        path: `/api/admin/v1/getcsv`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name WfV1LoginCreate
     * @request POST:/api/wf/v1/login
     */
    wfV1LoginCreate: (data: LoginUserRequest, params: RequestParams = {}) =>
      this.request<LoginUserResponse, LoginUserResponse>({
        path: `/api/wf/v1/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name V1ClickList
     * @request GET:/api/v1/click
     */
    v1ClickList: (params: RequestParams = {}) =>
      this.request<GetEnabledButtonsResponse, GetEnabledButtonsResponse>({
        path: `/api/v1/click`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name V1ClickCreate
     * @request POST:/api/v1/click
     */
    v1ClickCreate: (data: ClickButtonRequest, params: RequestParams = {}) =>
      this.request<ClickButtonResponse, ClickButtonResponse>({
        path: `/api/v1/click`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name V1ClickmultiCreate
     * @request POST:/api/v1/clickmulti
     */
    v1ClickmultiCreate: (data: ClickButtonMultipleRequest, params: RequestParams = {}) =>
      this.request<ClickButtonResponse, ClickButtonResponse>({
        path: `/api/v1/clickmulti`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name V1UnclickCreate
     * @request POST:/api/v1/unclick
     */
    v1UnclickCreate: (data: UnClickButtonRequest, params: RequestParams = {}) =>
      this.request<UnClickButtonResponse, UnClickButtonResponse>({
        path: `/api/v1/unclick`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name V1StatList
     * @request GET:/api/v1/stat
     */
    v1StatList: (params: RequestParams = {}) =>
      this.request<ClickStatisticResponse, ClickStatisticResponse>({
        path: `/api/v1/stat`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
